import { css } from '@emotion/react';
import type { ReportDemographicData } from '~/exportReport/exportReportData.helpers';
import { ExportReportType } from '~/exportReport/exportReportType';
import type { ReportTableColumn } from '~/exportReport/table/ReportTable.model';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useLatLngSpreadsheetData } from '~/map/map/useSpreadsheetData.hook';
import type { ExportReportLocationParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

const wrapperStyle = css({
  padding: 20,
  maxWidth: 1000,
  margin: '0 auto',
});

type MapExportReportPreviewLocationProps = Readonly<{
  params: ExportReportLocationParams;
  template: ReportTemplate;
  tableColumns: ReadonlyArray<ReportTableColumn>;
  getDemographicLabel: (demographicId: string) => string | null;
  getDemographicData: (columnId: string, demographicId: string) => ReportDemographicData | null;
  isLoading: boolean;
}>;

export const MapExportReportPreviewLocationComponent = ({
  template, params, tableColumns, getDemographicData, getDemographicLabel, isLoading,
}: MapExportReportPreviewLocationProps) => {

  const spreadsheetData = useLatLngSpreadsheetData();
  const rowData = spreadsheetData.getRow(params.data.markerId);

  if (!rowData) {
    return null;
  }

  return (
    <div css={wrapperStyle}>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          latLng: {
            lat: rowData.lat,
            lng: rowData.lng,
          },
          heading: params.data.summary.heading,
          semiHeading: params.data.summary.semiHeading,
          description: params.data.summary.description,
        }}
        mapProps={{
          center: rowData,
          type: ExportReportType.Location,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
        isLoading={isLoading}
      />
    </div>
  );
};
